import React from 'react';
import './style.css';
import { useHistory } from 'react-router-dom';
import { getFile } from '@opu/utils';

const AuthorComponent = ({ data, widthWindow = 2000 }) => {
  let history = useHistory();
  const { id, name, image } = data;

  const goToBooks = (id, name) => {
    let params = new URLSearchParams();
    params.append('keyword', name);
    history.push({
      pathname: '/books',
      search: params.toString(),
    });
  };

  return (
    <div className="author-item-container" onClick={() => goToBooks(id, name)}>
      <img
        className="author-item-image"
        src={image ? getFile('author', image) : '/assets/images/author_avatar.png'}
        alt="author"
      />
      <div className="author-container-name">{name}</div>
    </div>
  );
};

export default AuthorComponent;
